import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ComponentsModule} from '../../components/components.module';
import {AppCrmBoardWidgetComponent} from './components/crm-board-widget/crm-board-widget.component';
import {AppCrmTasksWidgetComponent} from './components/crm-tasks-widget/crm-tasks-widget.component';
import {AppEdiFilesWidgetComponent} from './components/edi-files-widget/edi-files-widget.component';
import {TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';
import {httpLoaderFactory} from '../../app.module';
import {AppCrmCalendarWidgetComponent} from './components/crm-calendar-widget/crm-calendar-widget.component';
import {AppCrmTaskFilterWidgetComponent} from './components/crm-task-filter-widget/crm-task-filter-widget.component';
import {
    AppEtfContractFilterWidgetComponent
} from './components/etf-contract-filter-widget/etf-contract-filter-widget.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {
    AppEdiFilesWidgetSettingsComponent
} from './components/edi-files-widget/setting/edi-files-widget.settings.component';
import {AppWidgetRootSettingsComponent} from './components/widget-root/widget-settings/widget-root-settings.component';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {AppMaterialModule} from '../../../app/app.material.module';
import {
    AppTaskFilterWidgetSettingsComponent
} from './components/crm-task-filter-widget/setting/crm-task-filter-widget.settings.component';
import {
    AppContractFilterWidgetSettingsComponent
} from './components/etf-contract-filter-widget/setting/etf-contract-filter-widget.settings.component';
import {
    AppBoardWidgetSettingsComponent
} from './components/crm-board-widget/setting/crm-board-widget.settings.component';
import {
    AppTasksWidgetSettingsComponent
} from './components/crm-tasks-widget/setting/crm-tasks-widget.settings.component';
import {
    AppWidgetCreateNewSettingsComponent
} from './components/widget-create-new-settings/widget-create-new-settings.component'
import {MatSlideToggle} from '@angular/material/slide-toggle';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatIconModule} from '@angular/material/icon';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSelectModule} from '@angular/material/select';
import {MatPaginatorIntl, MatPaginatorModule} from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';
import {MyCustomPaginatorIntl} from '../../components/material/mat-paginator-localize';
import {
    AppTasksViewCalendarComponent
} from './components/crm-calendar-widget/tasks-view-calendar/tasks-view-calendar.component'
import {MatListModule} from '@angular/material/list'
import {
    AppCRMCalendarWidgetSettingsComponent
} from './components/crm-calendar-widget/setting/crm-calendar-widget.settings.component';
import {AppBoardSelectSettingsComponent} from './components/board-select-component/board-select.settings.component';
import {AppEtfBillWidgetComponent} from './components/etf-bill-widget/etf-bill-widget.component';
import {
    AppEtfBillWidgetSettingsComponent
} from './components/etf-bill-widget/setting/etf-bill-widget.settings.component';
import {
    LucideAngularModule,
    File,
    House,
    Menu,
    UserCheck,
    Building2,
    Wallet,
    History,
    BanknoteArrowUp,
    BanknoteArrowDown,
    UserStar,
    MoveDown,
    ArrowBigDownDash
} from 'lucide-angular';
import {MatBadgeModule} from '@angular/material/badge';
import { AppEtfContractTableWidgetComponent } from './components/etf-contract-table-widget/etf-contract-table-widget.component';
import { AppWidgetsBoardComponent } from './controller/widgets-board/widgets-board.component';
import {AppContractModule} from "../contracts/app.contract.module";

export class AppModule {
}

@NgModule({
    declarations: [
        AppWidgetsBoardComponent,
        AppCrmBoardWidgetComponent,
        AppBoardWidgetSettingsComponent,
        AppCrmTasksWidgetComponent,
        AppTasksWidgetSettingsComponent,
        AppEdiFilesWidgetComponent,
        AppEdiFilesWidgetSettingsComponent,
        AppCrmCalendarWidgetComponent,
        AppCrmTaskFilterWidgetComponent,
        AppTaskFilterWidgetSettingsComponent,
        AppEtfContractFilterWidgetComponent,
        AppWidgetRootSettingsComponent,
        AppContractFilterWidgetSettingsComponent,
        AppWidgetCreateNewSettingsComponent,
        AppTasksViewCalendarComponent,
        AppCRMCalendarWidgetSettingsComponent,
        AppBoardSelectSettingsComponent,
        AppEtfBillWidgetComponent,
        AppEtfBillWidgetSettingsComponent,
        AppEtfContractTableWidgetComponent
    ],
    imports: [
        CommonModule,
        ComponentsModule,
        MatInputModule,
        FormsModule,
        ReactiveFormsModule,
        DragDropModule,
        MatButtonModule,
        MatDialogModule,
        MatSlideToggle,
        AppMaterialModule,
        MatTooltipModule,
        MatIconModule,
        MatFormFieldModule,
        MatSelectModule,
        MatPaginatorModule,
        MatSortModule,
        MatListModule,
        MatBadgeModule,
        LucideAngularModule.pick({
            File,
            House,
            Menu,
            UserCheck,
            Building2,
            Wallet,
            History,
            BanknoteArrowUp,
            BanknoteArrowDown,
            UserStar,
            MoveDown,
            ArrowBigDownDash
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: httpLoaderFactory,
                deps: [HttpClient],
            },
            defaultLanguage: 'ru',
        }),
        AppContractModule
    ],

    exports: [
        AppWidgetsBoardComponent,
        AppCrmBoardWidgetComponent,
        AppCrmTasksWidgetComponent,
        AppEdiFilesWidgetComponent,
        AppCrmCalendarWidgetComponent,
        AppCrmTaskFilterWidgetComponent,
        AppEtfContractFilterWidgetComponent,
        AppWidgetRootSettingsComponent,
        AppWidgetCreateNewSettingsComponent,
        AppTasksViewCalendarComponent
    ],
    providers: [
        {
            provide: MatPaginatorIntl,
            useFactory: (translate:any) => {
                const service = new MyCustomPaginatorIntl();
                service.injectTranslateService(translate);
                return service;
            },
            deps: [TranslateService]
        },
    ]
})
export class AppWidgetModule {
}
